import { useQuery } from '@tanstack/react-query';

import { DrugsApi, type FetchInstructionParams } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useInstruction = (params: FetchInstructionParams) =>
  useQuery({
    queryKey: DrugsQueryKeys.getInstructionKey(params.drug_id),
    queryFn: async () => await DrugsApi.fetchInstruction(params),
    staleTime: Infinity,
    retry: false,
  });
